// Лучшая анимация “без нагрузки”: мини-обёртка + CSS

'use client';

import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

export default function RouteFade({ children }: { children: ReactNode }) {
  const pathname = usePathname();

  // key заставляет контейнер "пере-монтироваться" на каждом новом URL
  // => CSS-анимация запускается автоматически.
  return (
    <div key={pathname} className="route-fade">
      {children}
    </div>
  );
}
